import BaseForm from '@js/forms/base-form'

export class FormPasswordReset extends BaseForm {
  static getDataTemplate () {
    return {
      email: '',
      password: '',
      passwordResetCode: '',
    };
  }
  constructor () {
    super();
  }
  getPostPayload () {
    return {
      email: this.data.email,
      password: this.data.password,
      resetCode: this.data.passwordResetCode,
    };
  }
}
